module.exports = __webpack_public_path__ + "static/img/bg-id.14f8fc92.png";